import { useModuleBEM } from "@b2bportal/core-themes";
import { useCheckoutStateSelector } from "@checkout/context";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { AccountPrice } from "@hopper-b2b/types";
import { getWalletCreditPayAmount } from "@hsbc/wallet";
import clsx from "clsx";
import { getRewardsAmountToApply } from "../../state";
import styles from "./styles.module.scss";

interface RewardsAndCreditsLineItemProps {
  accountSpecific: { [key: string]: AccountPrice };
  fiatFormatOptions?: Intl.NumberFormatOptions;
}

export const RewardsAndCreditsLineItem = ({
  accountSpecific,
  fiatFormatOptions,
}: RewardsAndCreditsLineItemProps) => {
  const [block, cn] = useModuleBEM(styles, "RewardsAndCredit");
  const { t, formatRewardsCurrency, formatFiatCurrency } = useI18nContext();

  const creditPayAmount = useCheckoutStateSelector(getWalletCreditPayAmount);
  const rewardsAmountToPay = useCheckoutStateSelector(getRewardsAmountToApply);

  const rewards = Object.values(accountSpecific)[0];
  const formattedRewards = formatRewardsCurrency({
    ...rewards,
    value: rewardsAmountToPay,
  });

  const hasValidPay = creditPayAmount.value > 0 || rewardsAmountToPay > 0;

  return (
    <div className={clsx(block, { [cn("hidden")]: !hasValidPay })}>
      {creditPayAmount.value > 0 && (
        <div className={cn("container")}>
          <div className={cn("summary-item-label")}>
            {t("rewards.priceBreakdown.creditsApplied")}
          </div>
          <div className={cn("summary-item-value", { credits: true })}>
            {`- ${formatFiatCurrency(creditPayAmount, fiatFormatOptions)}`}
          </div>
        </div>
      )}

      {rewardsAmountToPay > 0 && (
        <div className={cn("container")}>
          <div className={cn("summary-item-label")}>
            {t("rewards.priceBreakdown.pointsApplied")}
          </div>
          <div className={cn("summary-item-value", { rewards: true })}>
            {`- ${formattedRewards}`}
          </div>
        </div>
      )}
    </div>
  );
};
